import { Injectable } from '@angular/core';
import { Router, ResolveEnd, ActivatedRouteSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApplicationInsights, IExceptionTelemetry} from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';
import { AppConfig } from 'app/app.config';


@Injectable()
export class AppInsightService {
  private routerSubscription: Subscription;
  private appInsights: ApplicationInsights;

  constructor(private router: Router,  private appConfig: AppConfig) {
    const appInsightKey = this.appConfig.getConfig('appInsightKey')
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: appInsightKey
      }
    });

    this.appInsights.loadAppInsights();
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
      const activatedComponent = this.getActivatedComponent(event.state.root);
      if (activatedComponent) {
        this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
      }
    });
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri });
  }

  logEvent(name?: any, value?: any) {

    this.appInsights.trackEvent(name,value);
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }

  logError(error: any) {
    const exception: IExceptionTelemetry = {error};
    this.appInsights.trackException(exception);
  }
}